/* oxlint-disable */
'use client';

import React, { useEffect, useState, useCallback } from 'react';

import FeatureList from '@/features/download/FeatureList';
import Header from '@/features/download/Header';

import InstallInstructions from '@/features/download/InstallIntructions';
import { userUIStore } from '@/stores/userUIStore';

const Download = () => {
  const [isIOS, setIsIOS] = useState(false);
  const [isAndroid, setIsAndroid] = useState(false);
  const [isInStandaloneMode, setIsInStandaloneMode] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const { isSidebarOpen } = userUIStore();

  useEffect(() => {
    const { userAgent } = window.navigator;
    const ios = /iPad|iPhone|iPod/.test(userAgent);
    const android = /Android|Linux/.test(userAgent);
    setIsIOS(ios);
    setIsAndroid(android);

    const standalone = (window.navigator as any).standalone === true
      || window.matchMedia('(display-mode: standalone)').matches;
    setIsInStandaloneMode(standalone);

    const handleBeforeInstallPrompt = (e: any) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        'beforeinstallprompt',
        handleBeforeInstallPrompt,
      );
    };
  }, []);

  const handleInstallClick = useCallback(() => {
    if (deferredPrompt) {
      (deferredPrompt as any).prompt();
      (deferredPrompt as any).userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        setDeferredPrompt(null);
      });
    }
  }, [deferredPrompt]);

  return (
    <div
      className={`${!isSidebarOpen ? 'pl-72' : 'pl-20'} w-full pt-24 max-md:pl-0`}
    >
      <div className="w-full">
        <Header />
        <main className="w-full flex flex-col items-center mt-6">
          <section className="w-full flex flex-col items-start gap-4">
            <FeatureList />
            <InstallInstructions
              isIOS={isIOS}
              isInStandaloneMode={isInStandaloneMode}
              isAndroid={isAndroid}
              handleInstallClick={handleInstallClick}
            />
          </section>
        </main>
      </div>
    </div>
  );
};

export default Download;
